<template>
    <div
        class="-mb-7 text-opacity-5 text-center text-primary-text text-5xl sm:text-7xl"
    >
        <slot></slot>
    </div>

    <div
        class="mb-16 text-3xl sm:text-4xl text-primary-text font-extrabold text-center"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {};
</script>
